import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { AuthProvider } from './context/AuthContext';
import { ScrollToTop } from './components/ScrollToTop';
import ProtectedRoute from './components/ProtectedRoute';
import Homepage from './pages/Homepage';
import Gallery from './pages/Gallery';
import AIMatchmaker from './pages/AIMatchmaker';
import ForTalent from './pages/ForTalent';
import FAQ from './pages/FAQ';
import Pricing from './pages/Pricing';
import CandidateProfile from './pages/CandidateProfile';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Cookies from './pages/Cookies';
import About from './pages/About';
import Contact from './pages/Contact';
import Newsletter from './pages/Newsletter';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import AuthCallback from './pages/auth/AuthCallback';
import Dashboard from './pages/dashboard/Dashboard';
import PaymentSuccess from './pages/PaymentSuccess';
import ComparePage from './pages/ComparePage';
import CandidatePortal from './pages/CandidatePortal';
import RecruiterProfile from './pages/RecruiterProfile';
import NotFound from './pages/NotFound';
import Onboarding from './pages/Onboarding';

// Detect session_id in URL hash synchronously to prevent race conditions
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <Routes>
      {/* Public routes */}
      <Route path="/" element={<Layout><Homepage /></Layout>} />
      <Route path="/gallery" element={<Layout><Gallery /></Layout>} />
      <Route path="/ai-matchmaker" element={<Layout><AIMatchmaker /></Layout>} />
      <Route path="/pricing" element={<Layout><Pricing /></Layout>} />
      <Route path="/pricing/success" element={<PaymentSuccess />} />
      <Route path="/candidate/:id" element={<Layout><CandidateProfile /></Layout>} />
      <Route path="/talent/:id" element={<CandidatePortal />} />
      <Route path="/recruiter/:hrId" element={<RecruiterProfile />} />
      <Route path="/privacy" element={<Layout><Privacy /></Layout>} />
      <Route path="/terms" element={<Layout><Terms /></Layout>} />
      <Route path="/cookies" element={<Layout><Cookies /></Layout>} />
      <Route path="/about" element={<Layout><About /></Layout>} />
      <Route path="/contact" element={<Layout><Contact /></Layout>} />
      <Route path="/for-talent" element={<Layout><ForTalent /></Layout>} />
      <Route path="/faq" element={<Layout><FAQ /></Layout>} />
      <Route path="/newsletter" element={<Layout><Newsletter /></Layout>} />
      {/* Public self-serve registration is now open — legacy waitlist links redirect to /register */}
      <Route path="/waitlist" element={<Navigate to="/register" replace />} />
      <Route path="/early-access" element={<Navigate to="/register" replace />} />
      {/* Auth routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/welcome" element={<Layout><Onboarding /></Layout>} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      {/* Compare page — protected */}
      <Route path="/compare" element={
        <ProtectedRoute requirePlan="intelligence">
          <ComparePage />
        </ProtectedRoute>
      } />
      {/* Dashboard - protected, no main layout */}
      <Route path="/dashboard/*" element={
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      } />
      {/* Catch-all 404 — soft redirect countdown to home */}
      <Route path="*" element={<Layout><NotFound /></Layout>} />
    </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </Router>
  );
}

export default App;
